import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import KonsesjonsforholdPersonMedAndel from './KonsesjonsforholdPersonMedAndel.jsx'
import CollapseIcon from '../../../images/expand copy 7.png'
import ExpandIcon from '../../../images/collapse copy 7.png'

class KonsesjonsforholdPersonMedAndelList extends Component {
    state = {
        personerMedAndel: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null        
    }

    getPersonerMedAndel = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/konsesjonsforhold/${this.props.konsesjonsforholdId}/personmedandel`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken                
            }
        })
        .then(({data}) => {
            this.setState({
                personerMedAndel: [...this.state.personerMedAndel, ...data.personerMedAndel],
                isLoading: false,
                continuationToken: data.nextContinuationToken
            })
        })
    }

    togglePersonerMedAndel = () => {
        if (this.props.antall == 0) return

        if (this.state.personerMedAndel.length == 0) {
            this.getPersonerMedAndel()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var antallInvolverte = this.state.continuationToken ? `${this.state.personerMedAndel.length}/${this.props.antall}` : this.props.antall        
        return (
            <li>
                <div className="section-header" onClick={this.togglePersonerMedAndel}>
                    { !this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw"></i></span>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('personermedandel')} ({antallInvolverte})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.personerMedAndel.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.personerMedAndel.map((p, index) => {return (<KonsesjonsforholdPersonMedAndel key={p.personMedAndelId} personMedAndel={p} antall={this.props.antall} isLast={index==this.state.personerMedAndel.length-1} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getPersonerMedAndel}>
                                <span>{t('hent.person')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(KonsesjonsforholdPersonMedAndelList)